import axios from './axios'

export const getSessionAlerts = data =>
  axios.get(`/session_alert`)

export const sendSessionAlertEmail = data =>
  axios.post(`/session_alert/send_email`, data)
